import { Icon, IconName } from 'libs/icons';
import { ToastContainer, toast } from 'react-toastify';

export function AppToastContainer() {
  return (
    <ToastContainer
      draggable
      pauseOnFocusLoss
      pauseOnHover
      role="alert"
      position="top-right"
      closeButton
      closeOnClick
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
    />
  );
}

export function triggerSuccessToast(description: string): void {
  toast.success(description, {
    className: 'text-success',
    progressClassName: 'bg-success',
    icon: <Icon name={IconName.CheckMark} className="text-success" size={16} />
  });
}

export function triggerInfoToast(description: string): void {
  toast.info(description, {
    className: 'text-info',
    progressClassName: 'bg-info',
    icon: <Icon name={IconName.Info} className="text-info" size={16} />
  });
}

export function triggerWarningToast(description: string): void {
  toast.warn(description, {
    className: 'text-warn',
    progressClassName: 'bg-warn',
    icon: <Icon name={IconName.Warning} className="text-warn" size={16} />
  });
}

export function triggerErrorToast(description: string): void {
  toast.error(description, {
    className: 'text-error',
    progressClassName: 'bg-error',
    icon: <Icon name={IconName.Warning} className="text-error" size={16} />
  });
}
